(function() {
  if (window._abhFirsatiControllerLoaded) {
    if (window.abhFirsatiInit) window.abhFirsatiInit();
    return;
  }
  window._abhFirsatiControllerLoaded = true;

  // 4 Özel Ücretsiz Soğuk Zincir Kargo Ürünü:
  // 10732058509621: XXL Jumbo Karides 3 KG (2.250 TL)
  // 15466273472821: Kılkuyruk Mercan Kasa 5-6 KG (1.750 TL)
  // 15466274619701: Çıtır Akdeniz Paşa Barbunu Kasa 5-6 KG (1.750 TL)
  // 15466276323637: Akdeniz Lokum Balığı Kasa 5-6 KG (1.750 TL)
  var FREE_SHIP_PRODUCT_IDS = [10732058509621, 15466273472821, 15466274619701, 15466276323637];
  var FREE_SHIP_CODE = 'KARIDES3KGKARGO';
  var APPLIED_STORAGE_KEY = 'abh_applied_discounts_v3';
  var TIMER_STORAGE_KEY = 'abh_firsati_deadline_v2';
  var REJECTED_STORAGE_KEY = 'abh_firsati_rejected_v2';
  var isSyncingCart = false;
  var lastDesiredCodes = null;
  window._abhOfferSlideIdx = window._abhOfferSlideIdx || 0;

  if (!window._origFetch) {
    window._origFetch = window.fetch.bind(window);
  }

  function isFreeShipProduct(productId) {
    return FREE_SHIP_PRODUCT_IDS.indexOf(Number(productId)) !== -1;
  }

  function getRejectedIds() {
    try {
      return JSON.parse(sessionStorage.getItem(REJECTED_STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function addRejectedId(pid) {
    var list = getRejectedIds();
    if (list.indexOf(pid) === -1) {
      list.push(pid);
      try { sessionStorage.setItem(REJECTED_STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    }
  }

  function fixCartRemoveButtons() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var items = drawer.querySelectorAll('.cart-drawer-item');
    var hasMultiple = items.length > 1;
    drawer.querySelectorAll('cart-remove-button').forEach(function(btn) {
      btn.clearCart = !hasMultiple;
    });
  }

  function refreshOfferSlides() {
    document.querySelectorAll('[data-sepet-firsati-card]').forEach(function(card) {
      card.style.display = 'block';
      var allSlides = Array.prototype.slice.call(card.querySelectorAll('[data-firsati-slide]'));
      if (allSlides.length === 0) {
        card.style.display = 'none';
        return;
      }
      var rejected = getRejectedIds();
      var validSlides = allSlides.filter(function(s) {
        return rejected.indexOf(Number(s.getAttribute('data-product-id'))) === -1;
      });

      if (validSlides.length === 0) {
        try { sessionStorage.removeItem(REJECTED_STORAGE_KEY); } catch (e) {}
        validSlides = allSlides;
      }

      var idx = ((window._abhOfferSlideIdx % validSlides.length) + validSlides.length) % validSlides.length;
      allSlides.forEach(function(s) { s.classList.remove('is-active'); });
      validSlides[idx].classList.add('is-active');

      var navBtns = card.querySelectorAll('.sepet-firsati-nav');
      navBtns.forEach(function(btn) {
        btn.style.display = validSlides.length > 1 ? 'flex' : 'none';
      });
    });
    fixCartRemoveButtons();
  }

  window.abhFirsatiPrev = function(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e._abhHandled) return;
      e._abhHandled = true;
    }
    window._abhOfferSlideIdx = (window._abhOfferSlideIdx || 0) - 1;
    refreshOfferSlides();
  };

  window.abhFirsatiNext = function(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e._abhHandled) return;
      e._abhHandled = true;
    }
    window._abhOfferSlideIdx = (window._abhOfferSlideIdx || 0) + 1;
    refreshOfferSlides();
  };

  window.abhFirsatiReject = function(e, productId) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e._abhHandled) return;
      e._abhHandled = true;
    }
    if (!productId && e && e.target) {
      var slide = e.target.closest('[data-firsati-slide]');
      if (slide) productId = slide.getAttribute('data-product-id');
    }
    if (productId) addRejectedId(Number(productId));
    refreshOfferSlides();
  };

  function tickOfferTimer() {
    var cards = document.querySelectorAll('[data-sepet-firsati-card]');
    if (cards.length === 0) return;

    var drawer = document.querySelector('cart-drawer');
    var isDrawerOpen = drawer && drawer.classList.contains('active');
    var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
    if (!isDrawerOpen && !isCartPage) return;

    var deadline = Number(sessionStorage.getItem(TIMER_STORAGE_KEY) || 0);
    var now = Date.now();

    if (!deadline || deadline <= now) {
      if (deadline && deadline <= now) {
        window._abhOfferSlideIdx = (window._abhOfferSlideIdx || 0) + 1;
        refreshOfferSlides();
      }
      deadline = now + 60 * 1000;
      try { sessionStorage.setItem(TIMER_STORAGE_KEY, String(deadline)); } catch (e) {}
    }

    var remainingSec = Math.max(1, Math.ceil((deadline - now) / 1000));
    var mm = String(Math.floor(remainingSec / 60)).padStart(2, '0');
    var ss = String(remainingSec % 60).padStart(2, '0');

    document.querySelectorAll('[data-sepet-firsati-timer]').forEach(function(el) {
      el.textContent = mm + ':' + ss;
    });
  }

  setInterval(tickOfferTimer, 1000);

  window.abhFirsatiAccept = async function(e, variantId, productId) {
    var btn = null;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e._abhHandled) return;
      e._abhHandled = true;
      btn = e.target && e.target.closest ? e.target.closest('.sepet-firsati-btn-accept') : e.currentTarget;
    }
    if (!variantId && btn) {
      var slide = btn.closest('[data-firsati-slide]');
      if (slide) {
        variantId = slide.getAttribute('data-variant-id');
        productId = slide.getAttribute('data-product-id');
      }
    }
    if (!variantId) return;

    if (btn) {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor...';
    }

    try {
      var origFetch = window._origFetch || window.fetch;
      var addRes = await origFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: { '_sepet_firsati': '100TL' }
          }],
          sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'],
          sections_url: window.location.pathname
        })
      });
      var addData = await addRes.json();

      if (addData && addData.sections) {
        updateCartDOMFromSections(addData.sections);
      } else if (window.location.pathname.indexOf('/cart') !== -1) {
        window.location.reload();
      }

      await syncCartDiscounts(true);
    } catch (err) {
      console.error('Firsati add error:', err);
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Siparişime Ekle';
      }
    }
  };

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var prevBtn = e.target.closest('.sepet-firsati-nav--prev');
    if (prevBtn) {
      window.abhFirsatiPrev(e);
      return;
    }
    var nextBtn = e.target.closest('.sepet-firsati-nav--next');
    if (nextBtn) {
      window.abhFirsatiNext(e);
      return;
    }
    var rejectBtn = e.target.closest('.sepet-firsati-btn-reject');
    if (rejectBtn) {
      var rSlide = rejectBtn.closest('[data-firsati-slide]');
      window.abhFirsatiReject(e, rSlide ? rSlide.getAttribute('data-product-id') : null);
      return;
    }
    var acceptBtn = e.target.closest('.sepet-firsati-btn-accept');
    if (acceptBtn) {
      var aSlide = acceptBtn.closest('[data-firsati-slide]');
      window.abhFirsatiAccept(
        e,
        aSlide ? aSlide.getAttribute('data-variant-id') : null,
        aSlide ? aSlide.getAttribute('data-product-id') : null
      );
      return;
    }
    // Instant pre-lock when clicking Add-to-Cart or Buy-It-Now on any of the 4 Free-Shipping campaign products
    var addForm = e.target.closest('form[action*="/cart/add"]');
    if (addForm) {
      var pagePid = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id;
      var formIdAttr = addForm.getAttribute('id') || '';
      var isFreeShipAdd = false;
      if (pagePid && FREE_SHIP_PRODUCT_IDS.indexOf(Number(pagePid)) !== -1) {
        isFreeShipAdd = true;
      }
      FREE_SHIP_PRODUCT_IDS.forEach(function(fpid) {
        if (formIdAttr.indexOf(String(fpid)) !== -1) isFreeShipAdd = true;
      });
      if (isFreeShipAdd) {
        if (lastDesiredCodes.indexOf(FREE_SHIP_CODE) === -1) {
          lastDesiredCodes.unshift(FREE_SHIP_CODE);
        }
        syncFormHiddenDiscountInput(lastDesiredCodes);
        document.cookie = 'discount_code=' + encodeURIComponent(lastDesiredCodes.join(',')) + '; path=/; max-age=86400; SameSite=Lax';
      }
    }
    // Checkout button click lock: ensure discount input & cookie are synchronously locked before navigation
    var checkoutBtn = e.target.closest('#CartDrawer-Checkout, #checkout, [name="checkout"]');
    if (checkoutBtn) {
      var domDiscountInput = document.querySelector('#CartDrawer-Form input[name="discount"], #cart input[name="discount"]');
      if (domDiscountInput && domDiscountInput.value && (!Array.isArray(lastDesiredCodes) || lastDesiredCodes.length === 0)) {
        lastDesiredCodes = domDiscountInput.value.split(',').filter(Boolean);
      }
      if (Array.isArray(lastDesiredCodes) && lastDesiredCodes.length > 0) {
        syncFormHiddenDiscountInput(lastDesiredCodes);
        document.cookie = 'discount_code=' + encodeURIComponent(lastDesiredCodes.join(',')) + '; path=/; max-age=86400; SameSite=Lax';
      }
    }
  }, true);

  document.addEventListener('submit', function(e) {
    if (!e.target) return;
    if ((e.target.id === 'CartDrawer-Form' || e.target.id === 'cart') && Array.isArray(lastDesiredCodes)) {
      syncFormHiddenDiscountInput(lastDesiredCodes);
      if (lastDesiredCodes.length > 0) {
        document.cookie = 'discount_code=' + encodeURIComponent(lastDesiredCodes.join(',')) + '; path=/; max-age=86400; SameSite=Lax';
      }
    }
  }, true);

  function updateCartDOMFromSections(sections) {
    var parser = new DOMParser();
    if (sections['cart-drawer']) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var curInner = document.querySelector('#CartDrawer .drawer__inner');
      if (newInner && curInner) {
        curInner.innerHTML = newInner.innerHTML;
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer.close) {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }
    }
    if (sections['cart-icon-bubble']) {
      var docBubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newBubble = docBubble.querySelector('.shopify-section') || docBubble.body;
      var curBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && curBubble) {
        curBubble.innerHTML = newBubble.innerHTML;
      }
    }
    if (sections['main-cart-items']) {
      var docItems = parser.parseFromString(sections['main-cart-items'], 'text/html');
      var newItems = docItems.querySelector('cart-items');
      var curItems = document.querySelector('cart-items');
      if (newItems && curItems) {
        curItems.innerHTML = newItems.innerHTML;
        curItems.classList.toggle('is-empty', newItems.classList.contains('is-empty'));
      }
    }
    if (sections['main-cart-footer']) {
      var docFooter = parser.parseFromString(sections['main-cart-footer'], 'text/html');
      var newFooter = docFooter.querySelector('#main-cart-footer');
      var curFooter = document.getElementById('main-cart-footer');
      if (newFooter && curFooter) {
        curFooter.innerHTML = newFooter.innerHTML;
        curFooter.classList.toggle('is-empty', newFooter.classList.contains('is-empty'));
      }
    }
    if (Array.isArray(lastDesiredCodes)) {
      syncFormHiddenDiscountInput(lastDesiredCodes);
    }
    refreshOfferSlides();
    tickOfferTimer();
  }

  function syncFormHiddenDiscountInput(desiredCodes) {
    var combined = Array.isArray(desiredCodes) ? desiredCodes.filter(Boolean).join(',') : '';
    document.querySelectorAll('#CartDrawer-Form, #cart').forEach(function(form) {
      var inputs = form.querySelectorAll('input[name="discount"]');
      if (!combined) {
        // NEVER leave an empty <input name="discount" value=""> in DOM because Shopify clears checkout discounts on empty value!
        inputs.forEach(function(inp) { inp.remove(); });
      } else {
        var inp = inputs[0];
        if (!inp) {
          inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'discount';
          form.appendChild(inp);
        }
        inp.value = combined;
        for (var i = 1; i < inputs.length; i++) {
          inputs[i].remove();
        }
      }
    });
  }

  async function syncCartDiscounts(forceUpdate) {
    if (isSyncingCart) return;
    isSyncingCart = true;
    try {
      var origFetch = window._origFetch || window.fetch;
      var res = await origFetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) {
        isSyncingCart = false;
        return;
      }
      var cart = await res.json();
      var items = Array.isArray(cart.items) ? cart.items : [];

      if (items.length === 0) {
        lastDesiredCodes = [];
        try {
          sessionStorage.removeItem(TIMER_STORAGE_KEY);
          sessionStorage.removeItem(REJECTED_STORAGE_KEY);
          sessionStorage.removeItem(APPLIED_STORAGE_KEY);
        } catch (e) {}
      }

      var normalItems = items.filter(function(i) { return !i.properties || i.properties._sepet_firsati !== '100TL'; });
      var upsellItems = items.filter(function(i) { return i.properties && i.properties._sepet_firsati === '100TL'; });

      if (normalItems.length === 0 && upsellItems.length > 0) {
        var lastSections = null;
        for (var idx = 0; idx < upsellItems.length; idx++) {
          var uItem = upsellItems[idx];
          var chRes = await origFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: uItem.key,
              quantity: uItem.quantity,
              properties: { '_sepet_firsati': '' },
              sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'],
              sections_url: window.location.pathname
            })
          });
          if (chRes.ok) {
            var chData = await chRes.json();
            cart = chData;
            if (chData.sections) lastSections = chData.sections;
          }
        }
        if (lastSections) {
          updateCartDOMFromSections(lastSections);
        } else if (window.location.pathname.indexOf('/cart') !== -1) {
          window.location.reload();
        }
      }

      var updatedItems = Array.isArray(cart.items) ? cart.items : [];
      var hasFreeShipItem = updatedItems.some(function(i) { return isFreeShipProduct(i.product_id); });
      var validNormalCount = updatedItems.filter(function(i) { return !i.properties || i.properties._sepet_firsati !== '100TL'; }).length;
      var validUpsellCount = updatedItems.filter(function(i) { return i.properties && i.properties._sepet_firsati === '100TL'; }).length;

      var upsellCode = '';
      if (validNormalCount > 0 && validUpsellCount > 0) {
        if (validUpsellCount === 1) upsellCode = 'FIRSAT100';
        else if (validUpsellCount === 2) upsellCode = 'FIRSAT200';
        else if (validUpsellCount >= 3) upsellCode = 'FIRSAT300';
      }

      var rawTotalCents = Number(cart.original_total_price || cart.total_price || 0);
      var upsellDeductionCents = (validNormalCount > 0 && validUpsellCount > 0) ? (Math.min(validUpsellCount, 3) * 10000) : 0;
      var effectiveSubtotalCents = rawTotalCents - upsellDeductionCents;

      // 2.500 TL (250000 kuruş) altında 4 özel kampanyalı üründe KARIDES3KGKARGO uygulanır.
      var needsFreeShipCode = hasFreeShipItem && (effectiveSubtotalCents < 250000);

      var desiredCodes = [];
      if (needsFreeShipCode) desiredCodes.push(FREE_SHIP_CODE);
      if (upsellCode) desiredCodes.push(upsellCode);

      lastDesiredCodes = desiredCodes.slice();
      syncFormHiddenDiscountInput(desiredCodes);

      var targetCodes = desiredCodes.slice().sort().join(',');
      var prevApplied = '';
      try { prevApplied = sessionStorage.getItem(APPLIED_STORAGE_KEY) || ''; } catch (e) {}

      if (desiredCodes.length > 0) {
        // NEVER clear discount_code cookie when we WANT a discount code active!
        document.cookie = 'discount_code=' + encodeURIComponent(desiredCodes.join(',')) + '; path=/; max-age=86400; SameSite=Lax';
        if (forceUpdate || prevApplied !== targetCodes) {
          await origFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: desiredCodes.join(',') })
          });
          try { sessionStorage.setItem(APPLIED_STORAGE_KEY, targetCodes); } catch (e) {}
        }
      } else if (prevApplied !== '') {
        // Only clear when we previously applied an automatic code and now the cart no longer qualifies
        document.cookie = 'discount_code=; Max-Age=0; path=/; SameSite=Lax';
        await origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
        try { sessionStorage.setItem(APPLIED_STORAGE_KEY, ''); } catch (e) {}
      }
    } catch (e) {
      console.error(e);
    } finally {
      isSyncingCart = false;
      refreshOfferSlides();
      tickOfferTimer();
    }
  }

  window.abhFirsatiInit = function() {
    refreshOfferSlides();
    tickOfferTimer();
  };

  if (!window._abhFetchWrapped) {
    window._abhFetchWrapped = true;
    window.fetch = async function() {
      var args = Array.prototype.slice.call(arguments);
      var response = await window._origFetch.apply(window, args);
      try {
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
        if (!isSyncingCart && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1)) {
          setTimeout(function() {
            refreshOfferSlides();
            tickOfferTimer();
            syncCartDiscounts(true);
          }, 80);
        }
      } catch (e) {}
      return response;
    };
  }

  function onReady() {
    refreshOfferSlides();
    tickOfferTimer();
    syncCartDiscounts(false);

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function() {
        if (Array.isArray(lastDesiredCodes)) {
          syncFormHiddenDiscountInput(lastDesiredCodes);
        }
        refreshOfferSlides();
        tickOfferTimer();
      });
      obs.observe(drawer, { attributes: true, childList: true, subtree: false, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
